"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalIdSuffixes = exports.ExternalSystemTypes = void 0;
var ExternalSystemTypes;
(function (ExternalSystemTypes) {
    ExternalSystemTypes["Epic"] = "epic";
})(ExternalSystemTypes = exports.ExternalSystemTypes || (exports.ExternalSystemTypes = {}));
var ExternalIdSuffixes;
(function (ExternalIdSuffixes) {
    ExternalIdSuffixes["EpicOSW"] = "epic_osw";
})(ExternalIdSuffixes = exports.ExternalIdSuffixes || (exports.ExternalIdSuffixes = {}));
//# sourceMappingURL=types.js.map